import { Box, Checkbox, FormControl, FormControlLabel, FormGroup } from '@material-ui/core';
import { useTheme } from '../../';
import React from 'react';
import omit from 'lodash/omit';
export function FlagField(props) {
    const onChange = (event, checked) => {
        props.input.onChange(checked);
    };
    const theme = useTheme();
    const { label, attached, ...rest } = props;
    return (React.createElement(Box, { p: attached ? 1 : 2, pl: 2, pb: attached ? 1 : 0, borderRadius: 4, style: { borderTopRightRadius: 0, borderTopLeftRadius: 0, borderTopWidth: 0, paddingTop: 10, marginTop: -3 }, border: attached ? `1px solid ${theme.palette.divider}` : '' },
        React.createElement(FormControl, { component: "fieldset" },
            React.createElement(FormGroup, { row: true },
                React.createElement(FormControlLabel, { label: label, style: { width: `100%` }, control: React.createElement(Checkbox, Object.assign({ checked: props.input.value || false, onChange: onChange, value: true }, omit(rest, 'fullWidth'))) })))));
}
//# sourceMappingURL=FlagField.js.map